import type en from "../en/studio";
import type { Messages } from "../../types";

const fr: Messages<typeof en> = {
  pageTitle: "Studio IA",
  versionHistory: "Historique des versions",
  showHistory: "Afficher l'historique des versions",
  hideHistory: "Masquer l'historique des versions",
  chatTab: "Discussion",
  previewTab: "Aperçu",
  viewLabel: "Vue du studio",
  previewLabel: "Aperçu de la boutique",
  pageSelect: "Page",
  pageHome: "Accueil",
  pageProducts: "Tous les produits",
  pageCollections: "Collections",
  languageSelect: "Langue de l'aperçu",
  device: "Appareil",
  desktop: "Ordinateur",
  tablet: "Tablette",
  mobile: "Mobile",
  editToggle: "Modifier textes, couleurs et photos directement",
  editDefaultOnly: "La modification directe fonctionne dans la langue par défaut de la boutique. Changez la langue de l'aperçu pour modifier.",
  editNotAllowed: "Vous n'avez pas l'autorisation de modifier le design de cette boutique.",
  refresh: "Actualiser l'aperçu",
  openNewTab: "Ouvrir dans un nouvel onglet",
  editHint: "Cliquez sur un texte pour l'écrire · cliquez sur une photo pour la changer · choisissez des couleurs — enregistré dans votre brouillon",
  cancelEdit: "Annuler",
  colorPrimary: "Marque",
  colorBackground: "Fond",
  colorText: "Texte",
  colorsLabel: "Couleurs du thème",
  saving: "Enregistrement…",
  saved: "Enregistré dans le brouillon",
  saveFailed: "Impossible d'enregistrer : {error}",
  dismiss: "Fermer",
  bridgeSave: "Enregistrer",
  bridgeCancel: "Annuler",
  errTarget: "Cet élément ne peut pas être modifié ici.",
  errPage: "Cette page n'existe plus. Actualisez l'aperçu.",
  errSection: "Cette section n'existe plus. Actualisez l'aperçu.",
  errField: "Ce champ ne peut pas être modifié directement.",
  errImage: "Choisissez une image de votre médiathèque.",
  errColor: "Choisissez une couleur valide.",
  heroTitle: "Décrivez-la. Nous la construisons.",
  heroSubtitle: "Dites à l'IA ce que vous vendez et le style que vous aimez — elle crée le thème, les pages et la navigation pour vous.",
  heroPlaceholder: "ex. : Je veux créer une boutique de vestes nommée Jaketo — uniquement des vestes pour hommes, devise MAD, au Maroc, site en français…",
  heroInputLabel: "Décrivez votre boutique",
  heroPlan: "Planifier",
  heroPlanHint: "Voir un plan étape par étape avant toute construction",
  heroGenerate: "Générer",
  heroOutOfCredits: "Vous n'avez plus de crédits — alimentez votre portefeuille pour continuer",
  heroFundNow: "Alimenter mon portefeuille →",
  heroTalk: "Vous ne savez pas par où commencer ? Parlez à une IA Storelancer",
};

export default fr;
